import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { MapZoomProps } from './types';

const useMapZoomStyles = makeStyles(({ spacing, palette }) => {
  return createStyles({
    zoomButtonsWrapper: {
      position: 'absolute',
      top: ({ zoomButtonsPosition, topOffset }: MapZoomProps) =>
        zoomButtonsPosition === 'top-right' || zoomButtonsPosition === 'top-left'
          ? `${(topOffset ?? 0) + 10}px`
          : 'unset',
      bottom: ({ zoomButtonsPosition }: MapZoomProps) =>
        zoomButtonsPosition === 'bottom-right' || zoomButtonsPosition === 'bottom-left'
          ? spacing(2.5)
          : 'unset',
      right: ({ zoomButtonsPosition }: MapZoomProps) =>
        zoomButtonsPosition === 'top-right' || zoomButtonsPosition === 'bottom-right'
          ? spacing(2.5)
          : 'unset',
      left: ({ zoomButtonsPosition }: MapZoomProps) =>
        zoomButtonsPosition === 'top-left' || zoomButtonsPosition === 'bottom-left'
          ? spacing(2.5)
          : 'unset',
      width: spacing(7.5),
      backgroundColor: palette.background.paper,
    },
    zoomIcon: {
      height: spacing(7),
    },
    zoomIconButton: {
      margin: 0,
      padding: 0,
    },
  });
});

export default useMapZoomStyles;
